// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UsageLimitModal - Dismissible upgrade funnel modal */

.usage-limit-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.usage-limit-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 16px;
  padding: 40px 36px;
  max-width: 440px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  position: relative;
}

.usage-limit-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #666;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  transition: color 0.2s ease;
}

.usage-limit-close:hover {
  color: #aeb9cc;
}

.usage-limit-title {
  color: #fdfdfd;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 24px 0;
}

/* Usage bar */
.usage-limit-bar-container {
  margin-bottom: 24px;
}

.usage-limit-bar-track {
  width: 100%;
  height: 10px;
  background: #333;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 8px;
}

.usage-limit-bar-fill {
  height: 100%;
  background: #ef4444;
  border-radius: 5px;
  transition: width 0.3s ease;
}

.usage-limit-bar-label {
  color: #aeb9cc;
  font-size: 14px;
}

.usage-limit-bar-label strong {
  color: #ef4444;
}

.usage-limit-bar-separator {
  color: #555;
}

.usage-limit-view-usage {
  color: #218aff;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s ease;
}

.usage-limit-view-usage:hover {
  color: #4da3ff;
  text-decoration: underline;
}

/* Tier comparison */
.usage-limit-tiers {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 28px;
  text-align: left;
}

.usage-limit-tiers-heading {
  color: #aeb9cc;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
}

.usage-limit-tier-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.usage-limit-tier-name {
  color: #fdfdfd;
  font-size: 14px;
  font-weight: 500;
}

.usage-limit-tier-price {
  color: #888;
  font-size: 13px;
  margin-left: 4px;
}

.usage-limit-tier-limit {
  color: #218aff;
  font-size: 14px;
  font-weight: 600;
}

/* Buttons */
.usage-limit-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.usage-limit-button-primary {
  display: inline-block;
  padding: 14px 40px;
  background: #218aff;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.usage-limit-button-primary:hover {
  background: #1a7aef;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(33, 138, 255, 0.3);
}

.usage-limit-button-primary:active {
  transform: translateY(0);
}

.usage-limit-button-secondary {
  display: inline-block;
  padding: 10px 32px;
  background: transparent;
  color: #aeb9cc;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #444;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.usage-limit-button-secondary:hover {
  background: #333;
  color: #fdfdfd;
  border-color: #555;
}

/* Responsive */
@media (max-width: 540px) {
  .usage-limit-card {
    padding: 28px 20px;
  }

  .usage-limit-title {
    font-size: 20px;
  }

  .usage-limit-button-primary {
    padding: 12px 32px;
    font-size: 15px;
  }

  .usage-limit-button-secondary {
    padding: 8px 24px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UsageLimitModal.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* UsageLimitModal - Dismissible upgrade funnel modal */\n\n.usage-limit-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.usage-limit-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 16px;\n  padding: 40px 36px;\n  max-width: 440px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  position: relative;\n}\n\n.usage-limit-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.usage-limit-close:hover {\n  color: #aeb9cc;\n}\n\n.usage-limit-title {\n  color: #fdfdfd;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 24px 0;\n}\n\n/* Usage bar */\n.usage-limit-bar-container {\n  margin-bottom: 24px;\n}\n\n.usage-limit-bar-track {\n  width: 100%;\n  height: 10px;\n  background: #333;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.usage-limit-bar-fill {\n  height: 100%;\n  background: #ef4444;\n  border-radius: 5px;\n  transition: width 0.3s ease;\n}\n\n.usage-limit-bar-label {\n  color: #aeb9cc;\n  font-size: 14px;\n}\n\n.usage-limit-bar-label strong {\n  color: #ef4444;\n}\n\n.usage-limit-bar-separator {\n  color: #555;\n}\n\n.usage-limit-view-usage {\n  color: #218aff;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.usage-limit-view-usage:hover {\n  color: #4da3ff;\n  text-decoration: underline;\n}\n\n/* Tier comparison */\n.usage-limit-tiers {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 28px;\n  text-align: left;\n}\n\n.usage-limit-tiers-heading {\n  color: #aeb9cc;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 0;\n}\n\n.usage-limit-tier-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n}\n\n.usage-limit-tier-name {\n  color: #fdfdfd;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.usage-limit-tier-price {\n  color: #888;\n  font-size: 13px;\n  margin-left: 4px;\n}\n\n.usage-limit-tier-limit {\n  color: #218aff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* Buttons */\n.usage-limit-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.usage-limit-button-primary {\n  display: inline-block;\n  padding: 14px 40px;\n  background: #218aff;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.usage-limit-button-primary:hover {\n  background: #1a7aef;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(33, 138, 255, 0.3);\n}\n\n.usage-limit-button-primary:active {\n  transform: translateY(0);\n}\n\n.usage-limit-button-secondary {\n  display: inline-block;\n  padding: 10px 32px;\n  background: transparent;\n  color: #aeb9cc;\n  font-size: 14px;\n  font-weight: 500;\n  border: 1px solid #444;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.usage-limit-button-secondary:hover {\n  background: #333;\n  color: #fdfdfd;\n  border-color: #555;\n}\n\n/* Responsive */\n@media (max-width: 540px) {\n  .usage-limit-card {\n    padding: 28px 20px;\n  }\n\n  .usage-limit-title {\n    font-size: 20px;\n  }\n\n  .usage-limit-button-primary {\n    padding: 12px 32px;\n    font-size: 15px;\n  }\n\n  .usage-limit-button-secondary {\n    padding: 8px 24px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
